import {jsx} from 'panel';

import {mpColors} from 'common/util/colors';
import {isURL} from 'common/util/url';
import {SvgIconEl} from 'common/components/svg-icon';
import type {CellRenderContext} from 'common/components/data-table/types';

import {FunnelTableRow} from './types';
import type {FunnelsTable} from './index';

// Warning: css selectors in this file are styled by mp-data-table
// TODO: remove this obscure linkage

type RenderArgs = {
  item: FunnelTableRow;
  context: CellRenderContext;
};

export function getCellStatSigRenderer({setControl}: Pick<FunnelsTable['helpers'], 'setControl'>) {
  return function CellStatSig({item, context}: RenderArgs) {
    if (item.isControlGroup) {
      return (
        <>
          {!context.isComparison ? (
            <div sel='.statSig-svg-wrapper.control-group-icon'>
              <SvgIconEl
                attrs={{
                  icon: `status-light`,
                }}
              />
            </div>
          ) : null}
          <div sel='.statSig-value' class={{'is-comparison': context.isComparison}}>
            Control
          </div>
        </>
      );
    } else if (item.statSig) {
      const {confidence, status} = item.statSig;
      const isOverall = !confidence;

      return (
        <>
          {!context.isComparison ? (
            <div
              sel='.statSig-svg-wrapper'
              class={{'control-group-icon': isOverall}}
              on={{
                click: (ev) => setControl(ev, item),
              }}
            >
              {isOverall ? (
                <SvgIconEl
                  attrs={{
                    icon: `status-light`,
                  }}
                />
              ) : (
                <SvgIconEl
                  attrs={{
                    icon: `status-light`,
                    color: mpColors[status],
                  }}
                />
              )}
            </div>
          ) : null}
          <div sel='.statSig-value' class={{'is-comparison': context.isComparison}}>
            {isOverall ? `` : confidence}
          </div>
        </>
      );
    } else {
      return null;
    }
  };
}

export function SegmentName({item}: RenderArgs) {
  const isUrl = isURL(item.header);

  return isUrl ? (
    <a attrs={{href: item.header, target: `_blank`, title: item.header}}>{item.header}</a>
  ) : (
    <> {item.header} </>
  );
}
